module.exports = __webpack_public_path__ + "media/images/ceis-c5d338ca6d0d623cabb63f1174a6fe9c.png";